/**
 * Checks if a string contains patterns that indicate dynamic import failures.
 * @param text The text to check
 * @returns True if the text contains dynamic import failure patterns
 */
export function isDynamicImportErrorString(text: string): boolean {
    const lowerText = text.toLowerCase();

    return lowerText.includes("failed to fetch dynamically imported module");
}

/**
 * Checks if an error is related to dynamic import failures.
 * @param error The error to check
 * @returns True if the error is a dynamic import failure
 */
export function isDynamicImportError(error: Error): boolean {
    const errorMessage = error.message || "";
    const errorStack = error.stack || "";

    return error.name === "ChunkLoadError" || isDynamicImportErrorString(errorMessage) || isDynamicImportErrorString(errorStack);
}
